export const PAGE_SIZE_OPTIONS = [5, 10, 20, 30, 40, 50] as const; 